import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=aa244d30&scoped=true&"
import script from "./PageError.vue?vue&type=script&lang=js&"
export * from "./PageError.vue?vue&type=script&lang=js&"
import style0 from "./PageError.vue?vue&type=style&index=0&id=aa244d30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa244d30",
  null
  
)

export default component.exports